<div class="row d-flex justify-content-center mat-padding">
    <mat-card class="col-10 col-lg-6">
        <mat-card-content class="d-flex flex-column justify-content-center align-items-center">
            <div class="text-danger d-flex mb-8 column-gap-4">
                <mat-icon>report</mat-icon>
                <h1 class="no-margin">Unauthorized</h1>
                <mat-icon>report</mat-icon>
            </div>
            <h3 class="text-center">
                You are not authorized to see this page. Please click
                <a class="clickable" [routerLink]="['/']" routerLinkActive="router-link-active">here</a>
                to navigate to the app selection page, or email support at support&#64;arcuslm.com if you found this
                page to be in error.
            </h3>
        </mat-card-content>
    </mat-card>
</div>
